(function () {
  if (window.HLKlaviyoNewsletterInitialized) return;
  window.HLKlaviyoNewsletterInitialized = true;

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(form, message) {
    var errorContainer = form.querySelector('[data-newsletter-error]');
    var errorMessage = form.querySelector('[data-newsletter-error-message]');
    var inputWrapper = form.querySelector('[data-newsletter-input-wrapper]');

    if (errorContainer && errorMessage && inputWrapper) {
      errorMessage.textContent = message;
      errorContainer.classList.add('show');
      inputWrapper.classList.add('error');
    }
  }

  function hideError(form) {
    var errorContainer = form.querySelector('[data-newsletter-error]');
    var inputWrapper = form.querySelector('[data-newsletter-input-wrapper]');

    if (errorContainer && inputWrapper) {
      errorContainer.classList.remove('show');
      inputWrapper.classList.remove('error');
    }
  }

  function showSuccess(form) {
    var successMessage = form.querySelector('[data-newsletter-success]');
    if (successMessage) {
      successMessage.style.display = 'block';
    }
  }

  function setButtonLoading(button, loadingText) {
    if (!button) return '';
    var originalText = button.textContent;
    button.disabled = true;
    button.classList.add('loading');
    button.textContent = loadingText;
    return originalText;
  }

  function resetButton(button, originalText) {
    if (!button) return;
    button.disabled = false;
    button.classList.remove('loading');
    button.textContent = originalText;
  }

  function buildPayload(email, listId) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    };
  }

  function initForm(form) {
    var emailInput = form.querySelector('[data-newsletter-email]');
    var submitButton = form.querySelector('[data-newsletter-submit]');

    if (!emailInput || !submitButton || form.dataset.initialized === 'true')
      return;
    form.dataset.initialized = 'true';

    var hasInteracted = false;
    var isSubmitting = false;
    var messages = {
      empty: form.dataset.messageEmpty || 'Please enter your email address',
      invalid:
        form.dataset.messageInvalid || 'Please enter a valid email address',
      loading: form.dataset.messageLoading || 'Loading...',
      blur: form.dataset.messageBlur || 'Please enter your email address',
      fallback:
        form.dataset.messageFallback ||
        'Subscription failed. Please try again later.',
    };

    emailInput.addEventListener('input', function () {
      hasInteracted = true;
      hideError(form);
    });

    emailInput.addEventListener('blur', function () {
      if (hasInteracted && emailInput.value.trim() === '') {
        showError(form, messages.blur);
      }
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (isSubmitting) return;

      var email = emailInput.value.trim();
      if (!email) {
        showError(form, messages.empty);
        return;
      }

      if (!validateEmail(email)) {
        showError(form, messages.invalid);
        return;
      }

      var companyId = (form.dataset.companyId || '').trim();
      var listId = (form.dataset.listId || '').trim();
      if (!companyId || !listId) {
        return;
      }

      isSubmitting = true;
      var originalText = setButtonLoading(submitButton, messages.loading);

      try {
        var endpoint =
          'https://a.klaviyo.com/client/subscriptions/?company_id=' +
          encodeURIComponent(companyId);
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            revision: '2024-02-15',
          },
          body: JSON.stringify(buildPayload(email, listId)),
        });
        var responseText = await response.text();
        var data = responseText ? JSON.parse(responseText) : null;

        if (!response.ok || (data && data.success === false)) {
          var errorMessage = messages.fallback;
          if (data && data.errors && data.errors[0] && data.errors[0].detail) {
            errorMessage = data.errors[0].detail;
          } else if (data && data.message) {
            errorMessage = data.message;
          }
          throw new Error(errorMessage);
        }

        form.reset();
        hideError(form);
        showSuccess(form);
      } catch (error) {
        showError(form, error.message || messages.fallback);
      } finally {
        isSubmitting = false;
        resetButton(submitButton, originalText);
      }
    });
  }

  function initAllForms() {
    document
      .querySelectorAll('[data-klaviyo-newsletter-form]')
      .forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllForms);
  } else {
    initAllForms();
  }

  document.addEventListener('shopify:section:load', initAllForms);
})();
